export function removeLeadingSlash (path) {
  return path.startsWith('/') ? path.slice(1) : path
}
